import { useState } from "react";
import App from "./App";
import CSVShippingPage from "./CSVShippingPage";
import ExcelProcessor from "./ExcelProcessor";

function Navigation() {
  const [csvOrdersData, setCsvOrdersData] = useState(null);

  const handleOrdersDataChange = (ordersData) => {
    setCsvOrdersData(ordersData);
  };

  return (
    <div>
      <nav className="navbar navbar-expand-lg navbar-dark bg-dark">
        <div className="container">
          <span className="navbar-brand">Shipping Calculator</span>
        </div>
      </nav>

      <div className="container-fluid">
        <CSVShippingPage onOrdersDataChange={handleOrdersDataChange} />
        <ExcelProcessor ordersCountTable={csvOrdersData} />
      </div>
    </div>
  );
}

export default Navigation;